import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Header2 from '../header2/index-two';
import Footer from '../footer';
import StickyBox from "react-sticky-box";

const ParameterTable = () => {
    const {id} = useParams();
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [amounts, setAmounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [kate, setKate] = useState([])
    const [subkat, setSubkat] = useState([])

    // Mengambil data dari API ketika komponen dimuat
    useEffect(() => {
        setLoading(true);
        axios.get(`https://bbpom-makassar.com/api/parameter-uji/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
        .then(response => {
            const apiData = response.data.par || []; // Mengambil array data dari elemen pertama
            setData(apiData);
            setKate(response.data.kat || {})
            setSubkat(response.data.sub?.nm_sub_kategory || '')
            setAmounts(Array(apiData.length).fill(0)); // Inisialisasi jumlah ke 0 untuk setiap parameter
            setLoading(false);
        })
        .catch(err => {
            console.error("Error fetching data:", err);
            setData([]);
            setAmounts([]);
            setError('Data parameter uji tidak dapat dimuat. Periksa kembali tautannya.');
            setLoading(false);
        });
    }, []);
    
    
    const getImage = () => {
      if(kate.type == 1){
        return require('../../assets/img/user/pangan.png');
      }else if(kate.type == 2){
        return require('../../assets/img/user/kosmetik.png');
      }else if(kate.type == 3){
        return require('../../assets/img/user/obat.png');
      }else if(kate.type == 4){
        return require('../../assets/img/user/ot.png');
      }
    }

    const getMenu = () => {
      if(kate.type == 1){
        return '/kategory/pangan';
      }else if(kate.type == 2){
        return '/kategory/kosmetik';
      }else if(kate.type == 3){
        return '/kategory/obat';
      }else if(kate.type == 4){
        return '/kategory/obat-bahan-alam';
      } 
    }

    // Fungsi untuk menghitung total biaya berdasarkan input jumlah
        const calcTotal = (updatedAmounts = amounts) => {
        const newTotal = data.reduce((sum, item, index) => {
        const price = parseFloat(item.biaya) || 0;
        const amount = parseFloat(updatedAmounts[index]) || 0;
        return sum + price * amount;
          }, 0);
          setTotal(newTotal);
      };

    // Fungsi untuk mereset total dan semua input jumlah
    const resetCalc = () => {
        setAmounts(Array(data.length).fill(0));
        setTotal(0);
    };

    const handleAmountChange = (index, value) => {
        const updatedAmounts = [...amounts];
        updatedAmounts[index] = value;
        setAmounts(updatedAmounts);
    
        // Panggil fungsi calcTotal untuk menghitung ulang total
        calcTotal(updatedAmounts);
    };
    return (
        <div>
            <div className="main-wrapper">
            <Header2  />
              {/* Page Content */}
              <div className="page-content">
                <div className="container">
                  <div className="row">
                    {/* sidebar */}
                    <div className="col-xl-3 col-lg-3 theiaStickySidebar">
                      <StickyBox offsetTop={20} offsetBottom={20}>
                        <div className="settings-widget dash-profile">
                          <div className="settings-menu">
                            <div className="profile-bg">
                              <div className="profile-img">
                                <Link to={getMenu()}>
                                  <img src={getImage()} alt="Img" />
                                </Link>
                              </div>
                            </div>
                            <div className="profile-group">
                              <div className="profile-name text-center">
                                <h4>
                                  <Link to="/student/student-profile">{subkat}</Link>
                                </h4>
                                <p>{kate.nm_kategory}</p><br />
                                  {/* Order Tabs */}
                                  <div className="wishlist-tab order-tab d-flex justify-content-center" >
                                      <ul className="nav">
                                        <li className="nav-item">
                                          <Link
                                            onClick={resetCalc}
                                            className='active text-center'
                                          >
                                          Reset Total Biaya
                                          </Link>
                                        </li>
                                      
                                      </ul>
                                  </div>
                                  {/* /Order Tabs */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </StickyBox>
                    </div>
                    {/* /Sidebar */}
                    {/* Student Order History */}
                    <div className="col-xl-9 col-lg-9">
                      <div className="settings-widget card-details">
                        <div className="settings-menu p-0">
                          <div className="profile-heading">
                            <h3>Order List</h3>
                          </div>
                        <div className="checkout-form">
                          {/* Order Tabs */}
                          <div className="wishlist-tab order-tab">
                            <ul className="nav">
                              <li className="nav-item">
                                <Link
                                  to="#"
                                  className="active"
                                  data-bs-toggle="tab"
                                  data-bs-target="#today"
                                >
                                Total Biaya:{total.toLocaleString("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0, maximumFractionDigits: 0  }).replace("IDR", "").trim()}
                                </Link>
                              </li>
                            </ul>
                          </div>
                          {/* /Order Tabs */}
                          {/* Tab Content */}
                          <div className="tab-content">
                            <div className="table-responsive custom-table">
                                {loading ? ( <center>
                                    <div className="spinner-border text-center"></div>  
                                  </center>) : error ? (
                                  <center>
                                    <p>{error}</p>
                                  </center>
                                  ) :
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Nama Parameter</th>
                                            <th>Biaya Pengujian (Rp)</th>
                                            <th>Jumlah</th>
                                            <th>Metode</th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item, index) => (
                                          <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.parameter}</td>
                                            <td>{item.biaya}</td>
                                            <td >
                                              <input style={{width:'50px'}}
                                                  type="number"
                                                  min="0"
                                                  value={amounts[index]}
                                                  onChange={(e) => handleAmountChange(index, e.target.value)}
                                              />
                                            </td>
                                            <td>{item.metode || '-'}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                </table>
                                }
                                
                            </div><br />
                            {/* Order Tabs */}
                            <div className="wishlist-tab order-tab">
                              <ul className="nav">
                                <li className="nav-item">
                                  <Link
                                    to="#"
                                    className="active"
                                    data-bs-toggle="tab"
                                    data-bs-target="#today"
                                  >
                                  Total Biaya:{total.toLocaleString("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0, maximumFractionDigits: 0   }).replace("IDR", "").trim()}
                                  </Link>
                                </li>
                              
                              </ul>
                            </div>
                            {/* /Order Tabs */}
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <Footer />
            </div>
            {/* Menampilkan Total Biaya */}
          
            {/* Tombol Reset */}
            
        </div>
    );
};

export default ParameterTable;
